<template>
  <div class="role">
    <div class="card-container">
      <!-- <div class="card-title">
        监管数据筛选(监管照片)
      </div> -->
      <div class="card-content">
        <a-form :form="form" @submit="handleSubmit">
          <a-row>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="监管小区"
              >
                <a-select
                  v-decorator="[
                    'community',
                  ]"
                  show-search
                  placeholder="请选择"
                  :filter-option="filterOption"
                  @change="changeArea"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.housingEstate"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="5">
              <a-form-item
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 19 }"
                label="监管点位"
              >
                <a-select
                  v-decorator="[
                    'communis',
                  ]"
                >
                  <a-select-option
                    v-for="(item, index) in lists"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="4" align="right">
              <a-form-item>
                <a-button type="primary" class="mr8" html-type="submit">
                  查询
                </a-button>
                <a-button @click="resetForm">
                  重置
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container mrt16">
      <a-row>
        <a-col :span="12">
          <div class="card-title">
            监管照片列表
          </div>
        </a-col>
      </a-row>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="formData"
          :loading="loading"
          :pagination="pagination"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :row-key="record => record.id"
          @change="handleTableChange"
        >
          <template slot="deliveryState" slot-scope="text, record">
            <span v-if="text === 1">按钮投递</span>
            <span v-else>刷卡投递</span>
          </template>
          <template slot="detail" slot-scope="text, record">
            <a-button
              class="table-btn-link" type="link" size="small"
              @click="linkDetail(record)"
            >
              查看图片
            </a-button>
          </template>
          <template slot="productStatus" slot-scope="text">
            <div style="display: flex; align-items: center">
              <span v-if="text && text != '正常'" style="width:6px;height:6px;background:#F22635;margin-right:10px;border-radius:50%;"></span> {{ text }}
            </div>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import { getProductList, getProductPhoto, getPhotoList, getDeviceVideo, getEstateProduct } from '@/api/system'
import {
  getArea,
  getEstate,
  iconFontComponent
} from '@/components/mixins/mixins.js'
import moment from 'moment'
const columns = [
  {
    title: '区域',
    dataIndex: 'areaName'
  },
  {
    title: '小区',
    dataIndex: 'housingEstate'
  },
  {
    title: '点位名称',
    dataIndex: 'productName'
  },
  {
    title: '投递方式',
    dataIndex: 'deliveryState',
    scopedSlots: { customRender: 'deliveryState' }
  },
  // {
  //   title: '设备型号',
  //   dataIndex: 'productMark'
  // },
  // {
  //   title: '设备编号',
  //   dataIndex: 'productNumber'
  // },
  {
    title: '最新投递时间',
    dataIndex: 'deliveryDate'
  },
  // {
  //   title: '设备当前状态',
  //   dataIndex: 'productStatus',
  //   scopedSlots: { customRender: 'productStatus' }
  // },
  // {
  //   title: '关联人员',
  //   scopedSlots: { customRender: 'member' }
  // },
  {
    title: '操作',
    width: 120,
    fixed: 'right',
    scopedSlots: { customRender: 'detail' }
  }
]

export default {
  mixins: [getArea, getEstate, iconFontComponent],
  data () {
    return {
      spinImg: false,
      spinInOut: false,
      imgchoice: 'a',
      modelvisible: false,
      region: [],
      options: [],
      changeValue: 'img',
      imgvisible: false,
      imgdata: [],
      imgphoto: [],
      loading: false,
      userLoading: false,
      visible: false,
      columns,
      formData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },
      external: {},
      inside: {},
      imgId: '',
      starttime: '',
      recordItem: {},
      videoArr: [],
      showMissionList2: false,
      rangeConfig: {
        initialValue: [moment(), moment()],
        rules: [{ type: 'array' }]
      },
      times: [],
      selectedRowKeys: [],
      lists: []
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, {})
  },
  created: function () {
    this.getRoleList()
    this.getEstate()
    this.getArea('', 2)
  },

  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onChange (e) {
      this.spinInOut = true
      this.inside = {}
      const pamar = {
        id: this.imgId,
        type: e.target.value === 'b' ? 2 : 1
      }
      getPhotoList(pamar).then(res => {
        if (res.result.length !== 0) {
          this.inside = res.result[0]
          setTimeout(() => {
            this.spinInOut = false
          }, 1000)
        } else {
          this.spinInOut = false
        }
      })
    },
    showModal () {
      this.modelvisible = true
      // this.imgvisible = false
      this.spinInOut = true
      setTimeout(() => {
        this.spinInOut = false
      }, 1000)
    },
    viewImg (id, time) {
      this.external = {}
      const pamar = {
        id,
        type: 1
      }
      this.imgchoice = 'a'
      this.imgId = id
      this.starttime = time
      getPhotoList(pamar).then(res => {
        if (res.result.length !== 0) {
          this.external = res.result[0]
        }
      })
    },

    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    getRoleList () {
      const params = {
        // areaId: this.region[2] || '',
        // cityId: this.region[1] || '',

        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        estateName: this.form.getFieldValue('community') || '',
        productId: this.form.getFieldValue('communis') || ''
      }
      this.loading = true
      this.$httpPost(this.$basePath.getEquipmentList, params).then(res => {
        this.loading = false
        const result = res.result.list
        this.formData = result
        this.pagination.total = res.result.total
        // res.total ? res.total : 0
      })
    },
    changeArea (val) {
      console.log(val, '5555')
      this.getEstateProduct(val)
    },
    // 点位搜索
    getEstateProduct (estateName) {
      const params = {
        estateName: estateName
      }
      getEstateProduct(params).then((res) => {
        this.lists = res.result[0].children
      })
    },
    resetForm () {
      // this.form.resetFields()
      // this.type = '0'

      this.region = []
      // this.form.setFieldsValue({ estateId: undefined })
      this.form.resetFields()
      this.getRoleList()
      this.getEstate()
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getRoleList()
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.pagination.current = 1
          this.getRoleList()
        }
      })
    },
    handleChange (e) {
      const val = e.target.value
      this.changeValue = val
      if (val === 'img') {
        this.linkDetail(this.recordItem)
      } else if (val === 'video') {
        this.getDeviceVideo(this.recordItem)
      }
    },
    getDeviceVideo ({ id }) {
      const params = {
        id: id
      }
      getDeviceVideo(params).then(res => {
        const arr = res.result
        this.videoArr = []
        arr.forEach(item => {
          if (item.state === 0) {
            this.videoArr.push({
              src: `https://open.ys7.com/ezopen/h5/iframe?url=${item.url}&autoplay=1&accessToken=${item.token}`
            })
          } else {
            this.videoArr.push({
              msg: item.msg,
              name: item.name
            })
          }
        })
      })
    },
    linkDetail (item) {
      console.log(item, 'item')
      this.$router.push({ path: '/regulation/abnormalImg', query: { id: item.id }})
    },
    onClose () {
      this.imgvisible = false
      this.times = []
      this.imgphoto = []
      this.imgdata = []
    },
    toggle (item) {
      item.show = !item.show
    },
    onTime (val) {
      this.times = val
      this.linkDetail(this.recordItem)
    }
  }
}
</script>
<style scoped>
 /deep/ .ant-drawer-body {
    padding:24px 28px !important;
    margin: 0;
}
</style>
<style lang="stylus">
.role-modal .ant-modal-footer
  text-align center
.del-modal .ant-btn-primary
  display none
</style>
<style lang="stylus" scoped>
.eject_content
  .pic
    .pic_top
      display flex
      justify-content: space-between;
      margin-bottom: 15px;
      margin-top: 20px;
      span:nth-child(1)
        width: 5px;
        height: 16px;
        background: #1890ff;
        margin-right: 10px;
    .pic_bot
      display: flex;
      margin-bottom: 20px;
      flex-wrap: wrap;
      .img_list
        margin 10px 8px
        position: relative;
        img
          width 130px
          height 100px
          border-radius 4%
.modalimg
  text-align: center;
.qualified
  background: linear-gradient(315deg, transparent 50%, rgba(38, 181, 71, 1) 0%);
  width: 50px;
  height: 50px;
  border-top-left-radius: 5px;
.noqualified
  background: linear-gradient(315deg, transparent 50%, rgba(215, 45, 32, 1) 0%);
  width: 50px;
  height: 50px;
  border-top-left-radius: 5px;
.spanText
  position absolute
  top 7px
  transform rotate(-45deg)
  font-size 12px
  font-weight 400
</style>
